<div class="app-address-status" [style.color]="getColorByStatus" >
  @if (default) {
    <mat-icon>{{ 'done' }}</mat-icon>
  }
  {{ statusText }}
</div>
